import {
  CLOSED_OPPORTUNITY,
  CLOSED_OPPORTUNITY_ERROR,
  OPEN_OPPORTUNITY,
  OPEN_OPPORTUNITY_ERROR,
  DASHBOARD_GROUPED_COUNT,
  DASHBOARD_GROUPED_COUNT_ERROR,
  DASHBOARD_SALES_TREND,
  DASHBOARD_SALES_TREND_ERROR,
  DASHBOARD_GROUPED_BYSOURCE,
  DASHBOARD_GROUPED_BYSOURCE_ERROR,
  DASHBOARD_GROUPED_BYINDUSTRY,
  DASHBOARD_GROUPED_BYINDUSTRY_ERROR,
  DASHBOARD_GROUPED_BYACTIVITY,
  DASHBOARD_GROUPED_BYACTIVITY_ERROR,
  DASHBOARD_GROUPED_BY_EMAIL_ACTIVITY,
  DASHBOARD_GROUPED_BY_EMAIL_ACTIVITY_ERROR,
  DASHBOARD_GROUPED_BY_CALL_ACTIVITY,
  DASHBOARD_GROUPED_BY_CALL_ACTIVITY_ERROR,
  DASHBOARD_GROUPED_BY_MEETING_ACTIVITY,
  DASHBOARD_GROUPED_BY_MEETING_ACTIVITY_ERROR,
  DASHBOARD_CONVERTED_LEADS,
  DASHBOARD_CONVERTED_LEADS_ERROR,
  DASHBOARD_RECOMENDATION_COMPANY,
  DASHBOARD_RECOMENDATION_COMPANY_ERROR,
  DASHBOARD_RECOMENDATION_EMPLOYEE,
  DASHBOARD_RECOMENDATION_EMPLOYEE_ERROR,
  DASHBOARD_EXECUTIVE_SAVED_SEARCH,
  DASHBOARD_GROUPED_BYACTIVITY_STATUS,
  DASHBOARD_GROUPED_BYACTIVITY_STATUS_ERROR,
  COMPANY_TAG_LIST,
  EXECUTIVE_TAG_LIST,
} from "../actionType/dashboardType";
import {
  getDashboardClosedOpportunityApiUrl,
  getDashboardOpenOpportunityApiUrl,
  getDashboardGroupedCountApiUrl,
  getDashboardSalesTrendApiUrl,
  getDashboardGroupedBySourceApiUrl,
  getDashboardGroupedByIndustryApiUrl,
  getDashboardGroupedByActivityApiUrl,
  getDashboardGroupedByActivityStatusApiUrl,
  getDashboardGroupedByCallActivityApiUrl,
  getDashboardGroupedByMeetingActivityApiUrl,
  getDashboardGroupedByEmailActivityApiUrl,
  getDashboardConvertedLeadsApiUrl,
  getDashboardRecomendationCompanyApiUrl,
  getDashboardRecomendationEmployeeApiUrl,
  allTags,
} from "../constant/Constant";

import {
  getAuthMethod,
  patchAuthMethod,
  deleteAuthMethod,
} from "../services/HttpServices";
import { ErrKey, errEnum } from "../config";
import { LEAD_EXECUTIVE_COMPANY_TAG_LIST } from "../actionType/leadListingType";

export const getTopClosedOpportunity = (payload) => (dispatch) => {
  const url = `${getDashboardClosedOpportunityApiUrl}${payload?.userId ? `?userId.equals=${payload.userId}` : ""}`;
  return getAuthMethod(url)
    .then((res) => {
      dispatch({
        type: CLOSED_OPPORTUNITY,
        payload: res.data,
      });
    })
    .catch((err) => {
      if (!err?.response?.data) return;
      dispatch({
        type: CLOSED_OPPORTUNITY_ERROR,
        payload:
          { [errEnum.CLOSED_OPPORTUNITY_ERROR]: err.response.data[ErrKey] } ||
          "Error Occured",
      });
    });
};

export const getTopOpenOpportunity = (payload) => (dispatch) => {
  const url = `${getDashboardOpenOpportunityApiUrl}${payload?.userId ? `?userId.equals=${payload.userId}` : ""}`;
  return getAuthMethod(url)
    .then((res) => {
      dispatch({
        type: OPEN_OPPORTUNITY,
        payload: res.data,
      });
    })
    .catch((err) => {
      if (!err?.response?.data) return;
      dispatch({
        type: OPEN_OPPORTUNITY_ERROR,
        payload:
          { [errEnum.OPEN_OPPORTUNITY_ERROR]: err.response.data[ErrKey] } ||
          "Error Occured",
      });
    });
};

export const getGroupedCountData = (payload) => (dispatch) => {
  const url = `${getDashboardGroupedCountApiUrl}${payload?.userId ? `?userId.equals=${payload.userId}` : ""}`;
  return getAuthMethod(url)
    .then((res) => {
      dispatch({
        type: DASHBOARD_GROUPED_COUNT,
        payload: res.data,
      });
    })
    .catch((err) => {
      if (!err?.response?.data) return;
      dispatch({
        type: DASHBOARD_GROUPED_COUNT_ERROR,
        payload:
          {
            [errEnum.DASHBOARD_GROUPED_COUNT_ERROR]: err.response.data[ErrKey],
          } || "Error Occured",
      });
    });
};

export const getSalesTrendData = (payload) => (dispatch) => {
  const url = `${getDashboardSalesTrendApiUrl}${payload?.userId ? `?userId.equals=${payload.userId}` : ""}`;
  return getAuthMethod(url)
    .then((res) => {
      dispatch({
        type: DASHBOARD_SALES_TREND,
        payload: res.data,
      });
    })
    .catch((err) => {
      if (!err?.response?.data) return;
      dispatch({
        type: DASHBOARD_SALES_TREND_ERROR,
        payload:
          {
            [errEnum.DASHBOARD_SALES_TREND_ERROR]: err.response.data[ErrKey],
          } || "Error Occured",
      });
    });
};

export const getGroupedBySourceData = (payload) => (dispatch) => {
  const url = `${getDashboardGroupedBySourceApiUrl}${payload?.userId ? `?userId.equals=${payload.userId}` : ""}`;
  return getAuthMethod(url)
    .then((res) => {
      dispatch({
        type: DASHBOARD_GROUPED_BYSOURCE,
        payload: res.data,
      });
    })
    .catch((err) => {
      if (!err?.response?.data) return;
      dispatch({
        type: DASHBOARD_GROUPED_BYSOURCE_ERROR,
        payload:
          {
            [errEnum.DASHBOARD_GROUPED_BYSOURCE_ERROR]:
              err.response.data[ErrKey],
          } || "Error Occured",
      });
    });
};

export const getGroupedByIndustryData = (payload) => (dispatch) => {
  const url = `${getDashboardGroupedByIndustryApiUrl}${payload?.userId ? `?userId.equals=${payload.userId}` : ""}`;
  return getAuthMethod(url)
    .then((res) => {
      dispatch({
        type: DASHBOARD_GROUPED_BYINDUSTRY,
        payload: res.data,
      });
    })
    .catch((err) => {
      if (!err?.response?.data) return;
      dispatch({
        type: DASHBOARD_GROUPED_BYINDUSTRY_ERROR,
        payload:
          {
            [errEnum.DASHBOARD_GROUPED_BYINDUSTRY_ERROR]:
              err.response.data[ErrKey],
          } || "Error Occured",
      });
    });
};

export const getGroupedByActivityData = (payload) => (dispatch) => {
  const url = `${getDashboardGroupedByActivityApiUrl}${payload?.userId ? `?userId.equals=${payload.userId}` : ""}`;
  return getAuthMethod(url)
    .then((res) => {
      dispatch({
        type: DASHBOARD_GROUPED_BYACTIVITY,
        payload: res.data,
      });
    })
    .catch((err) => {
      if (!err?.response?.data) return;
      // console.log(err.response.status,err.response.data,'error data')
      dispatch({
        type: DASHBOARD_GROUPED_BYACTIVITY_ERROR,
        payload:
          { [errEnum.DASHBOARD_GROUPED_BYACTIVITY_ERROR]: err.response.data } ||
          "Error Occured",
      });
    });
};

export const getGroupedByActivityStatus = (payload) => (dispatch) => {
  const url = `${getDashboardGroupedByActivityStatusApiUrl}${payload?.userId ? `?userId.equals=${payload.userId}` : ""}`;
  return getAuthMethod(url)
    .then((res) => {
      dispatch({
        type: DASHBOARD_GROUPED_BYACTIVITY_STATUS,
        payload: res.data,
      });
    })
    .catch((err) => {
      if (!err?.response?.data) return;
      // console.log(err.response.status,err.response.data,'error data')
      dispatch({
        type: DASHBOARD_GROUPED_BYACTIVITY_STATUS_ERROR,
        payload:
          {
            [errEnum.DASHBOARD_GROUPED_BYACTIVITY_STATUS_ERROR]:
              err.response.data,
          } || "Error Occured",
      });
    });
};

export const getGroupedByCallActivityData = (payload) => (dispatch) => {
  const url = `${getDashboardGroupedByCallActivityApiUrl}${payload?.userId ? `?userId.equals=${payload.userId}` : ""}`;
  return getAuthMethod(url)
    .then((res) => {
      dispatch({
        type: DASHBOARD_GROUPED_BY_CALL_ACTIVITY,
        payload: res.data,
      });
    })
    .catch((err) => {
      if (!err?.response?.data) return;
      // console.log(err.response.status,err.response.data,'error data')
      dispatch({
        type: DASHBOARD_GROUPED_BY_CALL_ACTIVITY_ERROR,
        payload:
          {
            [errEnum.DASHBOARD_GROUPED_BY_CALL_ACTIVITY_ERROR]:
              err.response.data,
          } || "Error Occured",
      });
    });
};

export const getGroupedByMeetingActivityData = (payload) => (dispatch) => {
  const url = `${getDashboardGroupedByMeetingActivityApiUrl}${payload?.userId ? `?userId.equals=${payload.userId}` : ""}`;
  return getAuthMethod(url)
    .then((res) => {
      dispatch({
        type: DASHBOARD_GROUPED_BY_MEETING_ACTIVITY,
        payload: res.data,
      });
    })
    .catch((err) => {
      if (!err?.response?.data) return;
      // console.log(err.response.status,err.response.data,'error data')
      dispatch({
        type: DASHBOARD_GROUPED_BY_MEETING_ACTIVITY_ERROR,
        payload:
          {
            [errEnum.DASHBOARD_GROUPED_BY_MEETING_ACTIVITY_ERROR]:
              err.response.data,
          } || "Error Occured",
      });
    });
};

export const getGroupedByEmailActivityData = (payload) => (dispatch) => {
  const url = `${getDashboardGroupedByEmailActivityApiUrl}${payload?.userId ? `?userId.equals=${payload.userId}` : ""}`;
  return getAuthMethod(url)
    .then((res) => {
      dispatch({
        type: DASHBOARD_GROUPED_BY_EMAIL_ACTIVITY,
        payload: res.data,
      });
    })
    .catch((err) => {
      if (!err?.response?.data) return;
      // console.log(err.response.status,err.response.data,'error data')
      dispatch({
        type: DASHBOARD_GROUPED_BY_EMAIL_ACTIVITY_ERROR,
        payload:
          {
            [errEnum.DASHBOARD_GROUPED_BY_EMAIL_ACTIVITY_ERROR]:
              err.response.data,
          } || "Error Occured",
      });
    });
};

export const getConvertedLeadsData = (payload) => (dispatch) => {
  const url = `${getDashboardConvertedLeadsApiUrl}${payload?.userId ? `?userId.equals=${payload.userId}` : ""}`;
  return getAuthMethod(url)
    .then((res) => {
      dispatch({
        type: DASHBOARD_CONVERTED_LEADS,
        payload: res.data,
      });
    })
    .catch((err) => {
      if (!err?.response?.data) return;
      dispatch({
        type: DASHBOARD_CONVERTED_LEADS_ERROR,
        payload:
          {
            [errEnum.DASHBOARD_CONVERTED_LEADS_ERROR]:
              err.response.data[ErrKey],
          } || "Error Occured",
      });
    });
};

export const getRecomendationCompanyData = (payload) => (dispatch) => {
  const url = `${getDashboardRecomendationCompanyApiUrl}${payload?.userId ? `?userId.equals=${payload.userId}` : ""}`;
  return getAuthMethod(url)
    .then((res) => {
      dispatch({
        type: DASHBOARD_RECOMENDATION_COMPANY,
        payload: res.data,
      });
    })
    .catch((err) => {
      if (!err?.response?.data) return;
      dispatch({
        type: DASHBOARD_RECOMENDATION_COMPANY_ERROR,
        payload:
          {
            [errEnum.DASHBOARD_RECOMENDATION_COMPANY_ERROR]:
              err.response.data[ErrKey],
          } || "Error Occured",
      });
    });
};

export const getRecomendationEmployeeData = (payload) => (dispatch) => {
  const url = `${getDashboardRecomendationEmployeeApiUrl}${payload?.userId ? `?userId.equals=${payload.userId}` : ""}`;
  return getAuthMethod(url)
    .then((res) => {
      dispatch({
        type: DASHBOARD_RECOMENDATION_EMPLOYEE,
        payload: res.data,
      });
    })
    .catch((err) => {
      if (!err?.response?.data) return;
      dispatch({
        type: DASHBOARD_RECOMENDATION_EMPLOYEE_ERROR,
        payload:
          {
            [errEnum.DASHBOARD_RECOMENDATION_EMPLOYEE_ERROR]:
              err.response.data[ErrKey],
          } || "Error Occured",
      });
    });
};

export const saveSelectedExecutiveSearch = (payload) => (dispatch) => {
  dispatch({ type: DASHBOARD_EXECUTIVE_SAVED_SEARCH, payload: payload });
};

export const updateTag = (payload) => (dispatch) => {
  return patchAuthMethod(allTags, payload?.id, payload, {
    headers: {
      "Content-Type": "application/merge-patch+json",
    },
  })
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
};

export const deleteTag = (id) => (dispatch) => {
  return deleteAuthMethod(`${allTags}/${id}`)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      return err;
    });
};

export const getTagList = (type, userId) => (dispatch) => {
  const url = `${allTags}?type.equals=${type}${userId ? `&userId.equals=${userId}` : ""}`;
  return getAuthMethod(url)
    .then((res) => {
      if (type === "LEAD") {
        dispatch({
          type: LEAD_EXECUTIVE_COMPANY_TAG_LIST,
          payload: res?.data?.tagsDTOs,
        });
      } else if (type === "COMPANY") {
        dispatch({
          type: COMPANY_TAG_LIST,
          payload: res?.data?.tagsDTOs,
        });
      } else {
        dispatch({
          type: EXECUTIVE_TAG_LIST,
          payload: res?.data?.tagsDTOs,
        });
      }
    })
    .catch((err) => {
      return err;
    });
};

export const getAccessibleDashboardUsers = () => (dispatch) => {
  return getAuthMethod("/api/dashboard/accessible-users").then(
    (res) => res?.data || [],
  );
};
